import {SelectedValue} from './selectedValue'
import {ImageMeta} from './imageMeta'

/**
 * Class representing a content item
 */
export class BaseItem {
  /**
   * todo fix receipts and currency
   * Create a base for an item.
   * @param {Number} purchaseDate - the item purchase date in epoch
   * @param {AreaOfDamageImage[]} areaOfDamageImages - the array of damaged areas images with details
   * @param {ImageMeta} receipt - the receipt of the luggage
   * TODO: add the suitable logic for RECEIPTS and add currency string
   * @param {SelectedValue} price - the price of the item
   */
  constructor (purchaseDate, areaOfDamageImages, receipt, price) {
    this.purchaseDate = purchaseDate
    this.receipt = receipt
    this.price = price
    this.areaOfDamageImages = areaOfDamageImages !== undefined ? areaOfDamageImages : []
  }

  get purchaseDate () {
    return this._purchaseDate
  }

  set purchaseDate (value) {
    if (value) this._purchaseDate = Number(value)
    else this._purchaseDate = null
  }

  get areaOfDamageImages () {
    return this._areaOfDamageImages
  }

  set areaOfDamageImages (value) {
    this._areaOfDamageImages = value
  }

  get receipt () {
    return this._receipt
  }

  set receipt (value) {
    if (value && !(value instanceof ImageMeta)) {
      throw new TypeError('receipt is not an instance of ImageMeta')
    }
    this._receipt = value
  }

  get price () {
    return this._price
  }

  set price (value) {
    if (value && !(value instanceof SelectedValue)) {
      throw new TypeError('price is not an instance of SelectedValue')
    }
    this._price = value
  }

  toJSON () {
    return {
      purchaseDate: this._purchaseDate,
      areaOfDamageImages: this._areaOfDamageImages,
      receipt: this._receipt,
      price: this._price
    }
  }
}
